export const PROJECT_TYPE = ['all', 'delivery', 'invoice'] as const;

export const AI_MODEL_CHOICE_OPTIONS = ['all', 'di', 'ai_foundry'] as const;
